export enum ChangeFieldsEnum {
  ALLOWANCE = 'allowanceStatus',
  PRESENCE = 'presence',
  MATERIALS = 'materialStatus',
  PRERESOLUTION = 'preResolutionStatus',
  DISCIPLINE = 'hasDisciplinaryViolation'
}
